<template>
    <div class="app-membership__grid">
        <div>
            <span class="icon-wrap"><svg class="person-circle"><use xlink:href="#person-circle"></use></svg></span>
            <div class="content">
                <h3>Members-Only Community</h3>
                <p>Get the inside scoop from a like-minded community</p>
            </div>
        </div>
        <div>
            <span class="icon-wrap"><svg class="check-diamond"><use xlink:href="#check-diamond"></use></svg></span>
            <div class="content">
                <h3>Premium Booking Service</h3>
                <p>Personalized trip planning and 1:1 support</p>
            </div>
        </div>
        <div>
            <span class="icon-wrap"><svg class="loved-gate"><use xlink:href="#loved-gate"></use></svg></span>
            <div class="content">
                <h3>Trusted Recs</h3>
                <p>Recommendations curated to fit your travel style</p>
            </div>
        </div>
        <div>
            <span class="icon-wrap"><svg class="check-star"><use xlink:href="#check-star"></use></svg></span>
            <div class="content">
                <h3>Exclusive Member Perks</h3>
                <p>Including room upgrades, free breakfast, VIP welcome gifts and more.</p>
            </div>
        </div>
        <div>
            <span class="icon-wrap"><svg class="list-plus"><use xlink:href="#list-plus"></use></svg></span>
            <div class="content">
                <h3>Intuitive Planning Tools</h3>
                <p>Thoughtfully designed tools for the modern traveler</p>
            </div>
        </div>
        <div>
            <span class="icon-wrap"><svg class="check-tag"><use xlink:href="#check-tag"></use></svg></span>
            <div class="content">
                <h3>Worry Free Guarantee</h3>
                <p>Find your stay for less elsewhere? We’ll match the price.</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {}
</script>